import React from 'react';
import { Col } from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

class InputSelect extends AbstractComponent {  
    className() {
        return this.props.className !== undefined ? this.props.className : '';
    } 
    
    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }    

    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }
        
        return this.props.erro;
    }     

    onChangeSelect(input) {
        if(this.props.onChange !== undefined) {
            this.props.onChange(input);
        }
    }

    classNameInput() {
        return this.props.classNameInput !== undefined ? this.props.classNameInput : '';
    }

    onBlur(blur) {
        if (this.props.onBlur !== undefined) {
            this.props.onBlur(blur);
        }
    }    

    componentDidMount() {        
        if(!this.props.defaultFoco)
            return ;
        
        this.foco(this.props.nome);
    }
    
    render() {
        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg}
                style={this.props.style}
            >
                <div className={this.className() + ' ' + this.classErro()}>                    
                    <label htmlFor={this.props.nome}>
                        {this.props.children}
                    </label>                                                         

                    <select                        
                        value={this.props.value}                        
                        className={"form-control " + this.classNameInput()}
                        name={this.props.nome}
                        id={this.nome}
                        ref={this.props.ref}

                        onChange={input => this.onChangeSelect(input)}
                        onBlur={blur => this.onBlur(blur)}
                        onKeyPress={e => (this.props.onKeyPress !== undefined) ? this.props.onKeyPress(e) : ''}
                        disabled={this.props.disabled}
                    >
                        {
                            this.props.options.map((option, i) => {
                                return (
                                    <option     
                                        value={option[this.props.valor]} 
                                        key={i} 
                                        // selected={option.selected}
                                    >
                                        {option[this.props.texto]}
                                    </option>
                                )
                            })
                        }
                    </select>
                    
                    <span className="help-block">
                        {this.erro()}
                    </span>                    
                </div>
            </Col>
        )
    }
}

InputSelect.defaultProps = {
    md: '12',
    customClassComponent: '',
    valor: 'valor',
    texto: 'texto',
    className: ''
};

export default InputSelect;